export default "__VITE_ASSET__7b07e81b__"